import { render, staticRenderFns } from "./ProjectInvoicesModal.vue?vue&type=template&id=695b0f3f&"
import script from "./ProjectInvoicesModal.vue?vue&type=script&lang=js&"
export * from "./ProjectInvoicesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports